<template>
	<div
		v-if="variant && Object.keys(variant).length > 0"
		class="col-12 text-primary-white"
		:class="disabled ? '' : selected ? 'select bg-primary-green' : 'bg-primary-blue'"
		style="border-radius: var(--border-radius-button)"
	>
		<button
			v-if="!selected"
			:disabled="disabled"
			@click.stop="(e) => handleSelectClick(e)"
			class="cursor-pointer w-100 d-flex flex-row nowrap align-items-center justify-content-center select-btn button-primary text-primary-white buttons-default"
		>
			<svg v-if="!disabled" :width="24" :height="24" class="icon">
				<use xlink:href="#___icon___plus"></use>
			</svg>

			<span v-if="!disabled" class="ms-2">
				{{ content.planner_prestationsSelected }}
				<template v-if="hasSelection && accommodationOnly">
					(+ {{ accommodationWithCurrency }})
				</template>
			</span>
			<span v-else class="ms-2">{{ content?.planner_prestationsSelectedDisabled }}</span>
		</button>

		<div v-else class="d-flex flex-column w-100" @click.stop="handleDropdownClick">
			<div
				class="w-100 d-flex flex-row nowrap select-dropdown align-items-center buttons-default button-primary"
			>
				<button
					class="cursor-pointer dropdown-btn me-3 col-10 p-0"
				>
					<span
						class="d-flex flex-row nowrap align-items-center justify-content-end justify-content-md-center"
					>
						<span class="me-1">{{ selectedQuantity }}</span>
						<span v-if="selectedQuantity === 1">{{
							content.planningResult_hebergement
						}}</span>
						<span v-else>{{ content.planningResult_hebergements }}</span>

						<span class="me-2"></span>

						<span v-if="dropdownOpen" v-bind:class="addDnoneClassIfCgos">
							<svg :width="24" :height="24" class="icon me-2">
								<use xlink:href="#___icon___chevron-up-bold"></use>
							</svg>
						</span>
						<span v-else v-bind:class="addDnoneClassIfCgos">
							<svg color="white" :width="24" :height="24" class="icon me-2">
								<use xlink:href="#___icon___chevron-down-bold"></use>
							</svg>
						</span>
					</span>
				</button>

				<div class="col-1 p-0 d-flex justify-content-evenly align-items-center">
					<span>
						<svg class="icon" width="2" height="18">
							<use xlink:href="#___icon___verticalLine"></use>
						</svg>
					</span>

					<button class="cursor-pointer" @click.stop="handleClearClick">
						<svg width="24" height="24" class="icon">
							<use xlink:href="#___icon___close-white-x"></use>
						</svg>
					</button>
				</div>
			</div>

			<div class="position-relative" v-bind:class="addDnoneClassIfCgos">
				<HebergementDropdown
					:selected="selectedQuantity"
					:open="
						dropdownOpen && select_location === selectDropdownOpen_location
					"
					:totalAvailable="totalAvailable"
					@select="(newSelected) => handleDropdownSelect(newSelected)"
				/>
			</div>
		</div>
	</div>

	<PlaceholderBox :additionalClasses="'w-100'" :height="'45px'" v-else />
</template>

<script>
import { mapState } from "vuex"
import HebergementDropdown from "@/vue/planning/components/result/hebergementDropdownV2.vue"
import PlaceholderBox from "@/vue/planning/components/common/placeholderBox.vue"
import colors from "@/config/colors"
import store from "@/vue/planning/store/store"
import { checkIfCompanyIsCgos } from "@/utils/utils"


import displayPrice from "@/displayPrice/displayPrice"


export default {
	store,
	name: "SelectButton",
	props: {
		accommodationOnly: {
			type: String,
			default: undefined,
		},
		variant: {
			type: Object,
			default: () => {
				return {}
			},
		},
		selectedQuantity: {
			type: Number,
			default: 0,
		},
		select_location: {
			type: String,
			default: "prestation",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		locale: {
			type: String,
			default: "fr-FR",
		},
	},
	components: {
		HebergementDropdown,
		PlaceholderBox,
	},
	computed: {
		...mapState([
			"content",
			"selectDropdownOpen_prestId",
			"selectDropdownOpen_location",
		]),
		accommodationWithCurrency() {
			return this.displayPrice(parseInt(this.accommodationOnly)*100, this.locale)
		},
		selected() {
			if (this.selectedQuantity > 0) {
				return true
			}
			return false
		},
		hasSelection() {
			return Object.keys(store.state.selectedPrestIds).length > 0
		},
		style() {
			return {
				background: colors.lightBlue,
				color: "white",
			}
		},

		dropdownOpen() {
			return this.selectDropdownOpen_prestId === this.variant.id
		},
		addDnoneClassIfCgos() {
			const dNoneClass = checkIfCompanyIsCgos() ? "d-none" : ""
			return dNoneClass
		},
		totalAvailable() {
			// Here we need to add logic for CGOS AURA/PACA
			const maxCapacityPerAccommodation = this.variant.maxCapacity;
			const participants = this.$store.state.participants || [];
			// Return the lesser of the number of participants or the max capacity per accommodation
			return Math.min(participants.length, maxCapacityPerAccommodation);
		},
	},
	methods: {
		displayPrice,
		handleSelectClick() {
			this.$emit("selectClick", this.variant.id) // use prestId for flex / nonflex cases
		},

		handleDropdownClick() {
			this.$emit("dropdownClick", {
				id: this.variant.id,
				select_location: this.select_location,
			}) // use prestId for flex / nonflex cases
		},

		handleClearClick() {
			this.$emit("clear", this.variant.id) // use prestId for flex / nonflex cases
			this.$emit("dropdownClick", { id: "", select_location: "" })
		},

		handleDropdownSelect(newSelected) {
			this.$emit("dropdownSelect", {
				newSelected: newSelected,
				id: this.variant.id,
			}) // use prestId for flex / nonflex cases
		},
	},
	watch: {},
	mounted() {
		return
	},
}
</script>

<style scoped>
button {
	border: none;
	background: transparent;
	color: inherit;
}

.select-btn {
	transition: background 100ms ease-in-out;
}
</style>
